module.exports = __webpack_public_path__ + "_assets/img/binding02.d20ae85a.png";